import { render, staticRenderFns } from "./user-setup.component.vue?vue&type=template&id=4ce128b1"
import script from "./user-setup.component.ts?vue&type=script&lang=ts&external"
export * from "./user-setup.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports